/** Hindi: Find as a conversation. */
export const need = {
    "need.start": "आपको क्या काम करवाना है? अपने शब्दों में बताइए।",
    "need.ask.trade": "आपको किस तरह का कामगार चाहिए?",
    "need.again": "माफ़ कीजिए, मैं समझ नहीं पाया।",
    "need.ask.area": "काम किस इलाक़े में है?",
    "need.ask.when": "किसी को कब बुलाना है? समय भी बता सकते हैं, जैसे कल सुबह 10 बजे।",
    "need.ask.hour": "उन्हें किस समय आना चाहिए?",
    "when.hour": "{time}",
    "when.any_time": "किसी भी समय",
    "hour.morning": "सुबह {h} बजे",
    "hour.afternoon": "दोपहर {h} बजे",
    "hour.evening": "शाम {h} बजे",
    "need.ask.budget": "आप ज़्यादा से ज़्यादा कितना देंगे? यह इसी फ़ोन पर रहेगा; कामगारों को नहीं दिखेगा।",
    "need.band_month": "{city} में लोग आम तौर पर इसके लिए महीने का {low} से {high} देते हैं।",
    "need.band_visit": "{city} में लोग आम तौर पर इसके लिए एक बार का {low} से {high} देते हैं।",
    "need.again_budget": "रुपयों में रक़म बोलिए, जैसे सात सौ।",
    "need.got_budget": "ज़्यादा से ज़्यादा {price}, नोट कर लिया।",
    "need.err_long": "यह लंबा है। थोड़े शब्दों में बताइए।",
    "need.summary": "{area} में {trade}। कब: {when}।",
    "need.summary_time": "समय: {time}।",
    "need.summary_words": 'कामगार यह पढ़ेंगे: "{words}"',
    "need.summary_detail": "{question} {answer}",
    "need.summary_budget": "आप ज़्यादा से ज़्यादा {budget} देंगे। यह इसी फ़ोन पर रहेगा।",
    "need.confirm": "क्या मैं किसी को ढूँढूँ?",
    "need.what_change": "क्या बदलूँ?",
    "need.field_trade": "काम",
    "need.field_detail": "जानकारी",
    "need.field_budget": "मेरा बजट",
    "need.searching": "{area} के पास किसी को ढूँढ रहा हूँ…",
    "need.found": "पास में ये लोग मदद कर सकते हैं। तीन तक चुनिए, फिर पूछिए।",
    "need.nobody": "{km} किमी के अंदर अभी कोई नहीं मिला। थोड़ा और दूर देखूँ, या कुछ बदलें?",
    "need.change": "कुछ बदलें",
    "need.asked": "पूछ लिया। उनके एजेंट आपके एजेंट से बात करेंगे — 'मेरे काम' में देखते रहिए।",
    "need.start_to": "आपको {name} से क्या काम करवाना है? अपने शब्दों में बताइए।",
    "need.confirm_to": "क्या मैं {name} से पूछूँ?",
    "need.asking_to": "{name} से पूछ रहा हूँ…",
    "need.composer": "बताइए आपको क्या चाहिए",
    "need.placeholder": "लिखिए आपको क्या चाहिए…",
    "need.reading": "आपकी बात समझ रहा हूँ…",
    "need.date_ok": "यह तारीख़ रखें",
};
//# sourceMappingURL=need.js.map